import Call from '../Call.v3';

const BitbucketDnsDomainChecker = {
    create: (domains) => Call(`bullmq-task-consumers/bitbucket_dns_domain_checker`, 'POST', { domains }),
    get: () => Call(`bullmq-task-consumers/bitbucket_dns_domain_checker`),
    download: (id) => Call(`bullmq-task-consumers/bitbucket_dns_domain_checker/download/${id}`),
    get_results_distinct: () => Call(`bullmq-task-consumers/bitbucket_dns_domain_checker/results/distinct`),
};

export default BitbucketDnsDomainChecker;



// WEBPACK FOOTER //
// ./src/services/API/components/BitbucketDnsDomainChecker.js